import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ICsPagingParams} from "@app/shared/cs-components/cs-components.interface";
import {TCsPagingEvent} from "@app/shared/cs-components/cs-components.types";

@Component({
    selector: 'app-cs-pagination-panel',
    templateUrl: './cs-pagination-panel.component.html',
    styleUrls: ['cs-pagination-panel.component.scss']
})
export class CsPaginationPanelComponent implements OnInit {

    @Input() pageOffsetList = [5, 10, 20, 50, 100];
    @Input() pageList: number[];
    @Input() initialParams: ICsPagingParams;
    @Input() maxPagesDisplayLength = 10;
    @Input() dropUpCalcAddOnSpace = 0;  // Should be in `px` unit.

    @Input() set totalRecord(value: number) {
        this._totalRecord = value;
        if (this.pagingParams && value >= 0) {
            const pageSize = this.pagingParams.pageSize || 5;
            this.setPageSize(pageSize, 'none');
        }
    }

    @Output() onUpdatePagingParams = new EventEmitter<ICsPagingParams>();
    @Output() onInit = new EventEmitter<{ reset: () => void }>();

    pagingParams: ICsPagingParams;
    isDropUp = false;
    _totalRecord: number;

    constructor(private _hostRef: ElementRef) {
    }

    ngOnInit() {
        this.setInitialPagingParams();
        this.setPageList();
        this.setPaginationProps();
        this.updatePagingParams();
        this.init();
    }

    init() {
        this.onInit.emit({reset: this.resetPagingList});
    }

    onMenuShown() {
        this.setDropUp();
    }

    setDropUp() {
        const ddMenuHeight = (29 * this.pageOffsetList.length) + 2;
        const bottomBoundary = document.getElementsByTagName('body')[0].getBoundingClientRect().bottom - (this.dropUpCalcAddOnSpace || 0);
        const dropDownBottomPosition = this._hostRef.nativeElement.getBoundingClientRect().bottom;
        const availableBottomSpace = bottomBoundary - dropDownBottomPosition;

        this.isDropUp = availableBottomSpace <= ddMenuHeight;
    }

    setInitialPagingParams() {
        this.pagingParams = {
            currentPage: (this.initialParams && this.initialParams.currentPage) || 1,
            pageSize: (this.initialParams && this.initialParams.pageSize) || 5,
            startRow: null,
            endRow: null
        };
    }

    setPageList() {
        this.pageList = Array(Math.ceil(this._totalRecord / this.pagingParams.pageSize)).fill(0).map((_, i) => i + 1);
    }

    setPaginationProps() {
        const remainingLastPageRowCount = (this._totalRecord % this.pagingParams.pageSize);
        this.pagingParams.startRow = (this.pagingParams.pageSize * (this.pagingParams.currentPage - 1)) + 1;
        this.pagingParams.endRow = this.pageList.length === this.pagingParams.currentPage && remainingLastPageRowCount ? (this.pagingParams.startRow - 1) + remainingLastPageRowCount : this.pagingParams.pageSize * this.pagingParams.currentPage;
    }

    setPageSize(offset?: number, pagingEvent?: TCsPagingEvent, currentPage?: number) {
        this.pagingParams.currentEvent = pagingEvent || 'pageSize';
        this.pagingParams.pageSize = offset;
        this.pagingParams.currentPage = currentPage || Math.trunc(((this.pagingParams.startRow - 1) / this.pagingParams.pageSize)) + 1;
        this.setPageList();
        this.setPaginationProps();
        this.updatePagingParams();
    }

    setCurrentPage(page: number) {
        this.pagingParams.currentEvent = 'pageNav';
        this.pagingParams.currentPage = page;
        this.setPaginationProps();
        this.updatePagingParams();
    }

    resetPagingList = () => this.setPageSize(this.pagingParams.pageSize, 'none', 1);

    updatePagingParams() {
        this.onUpdatePagingParams.emit(this.pagingParams);
    }
}
